<script setup lang="ts">
  const { organizationUrl, organizationName } =
    useOrganizationStore();
</script>
<template>
  <header class="px-4 md:px-8 lg:px-4">
    <div class="mx-auto flex min-h-16 max-w-7xl items-center">
      <div class="flex flex-1 items-center gap-2">
        <ULink to="/" class="text-lg font-medium text-gray-900">
          <img
            src="/assets/images/logo.png"
            alt=""
            class="max-h-10"
          />
        </ULink>
        <UButton
          color="blue"
          variant="subtle"
          class="sm:tex-sm line-clamp-1 rounded-full text-xs text-ellipsis"
          :to="`/${organizationUrl}`"
          :label="organizationName!"
        />
      </div>
      <div class="flex items-center justify-end gap-2">
        <AppProfileMenu />
        <UPopover>
          <UButton variant="ghost" class="max-h-fit">
            <template #leading>
              <IconNineDots class="size-5" />
            </template>
          </UButton>
          <template #content>
            <OrganizationsPopover />
          </template>
        </UPopover>
      </div>
    </div>
  </header>
</template>
